import { create } from 'zustand'

export const showSignUpStore = create((set) => ({
  isShowSignUp: false,
  setShowSignUp: (value) => set({ isShowSignUp: value })
}))
